// import React from 'react';
// import PropTypes from 'prop-types';
// import { DOTS, usePagination } from './usePagination';
// import { ArrowLeftIcon, ArrowRightIcon } from '@heroicons/react/20/solid';


// const Pagination = (props) => {
//   const { onPageChange, totalCount, siblingCount = 1, currentPage, pageSize } = props;

//   const paginationRange = usePagination({
//     currentPage,
//     totalCount,
//     siblingCount,
//     pageSize
//   });

//   const onNext = () => {
//     onPageChange(currentPage + 1);
//   };

//   const onPrevious = () => {
//     onPageChange(currentPage - 1);
//   };

//   let lastPage = paginationRange[paginationRange.length - 1];

//   return (
//     <div className="px-8 py-6 bg-white dark:bg-shoorah-darkBgTabColor dark:border-none border-[1.5px] border-shoorah-borderGray rounded-[15px] mt-6">
//       {/* <div className="px-4 mx-3 py-4 bg-white dark:bg-shoorah-darkBgTabColor dark:border-none border-r border-l border-b border-gray-200 rounded-b-[15px]"> */}
//       <ul className="flex justify-between items-center mb-0">
//         <li
//           className={`${currentPage === 1 ? 'opacity-50' : 'cursor-pointer'} `}
//           onClick={currentPage !== 1 ? onPrevious : undefined}
//         >
//           <span
//             className={`relative inline-flex text-shoorah-lightBlack dark:bg-shoorah-darkBgColor dark:border-none dark:hover:bg-shoorah-darkBgColor dark:text-white items-center rounded-3xl border-[1.5px] border-shoorah-lightBlack bg-white px-5 py-[7px] text-[16px] font-medium hover:bg-gray-50 focus:z-20`}
//           >
//             {/* <ArrowLeftIcon className="h-5 w-5 md:mr-2" aria-hidden="true" /> */}
//             <span className="md:block hidden">Previous page</span>
//           </span>
//         </li>

//         <div className="hidden sm:flex space-x-2">
//           {paginationRange.map((pageNumber, index) => {
//             if (pageNumber === DOTS) {
//               return (
//                 <span
//                   key={index}
//                   className="relative inline-flex items-center dark:bg-inherit dark:text-white bg-white px-3 py-2 text-sm font-medium text-[#606060]"
//                 >
//                   ...
//                 </span>
//               );
//             }

//             return (
//               <div key={index} className="flex items-center">
//                 <li
//                   onClick={() => onPageChange(pageNumber)}
//                   className={`cursor-pointer w-[45px] h-[45px] flex justify-center items-center ${
//                     pageNumber === currentPage
//                       ? 'border-indigo-500 text-sm dark:text-lg dark:font-semibold bg-indigo-50 text-indigo-600'
//                       : 'border-gray-300 bg-white text-sm text-[#606060] hover:bg-gray-100'
//                   } text-center dark:bg-shoorah-darkBgColor hover:dark:bg-shoorah-darkBgColor dark:text-white rounded-[50%]  font-medium focus:z-20`}
//                 >
//                   <span>{pageNumber}</span>
//                 </li>
//               </div>
//             );
//           })}
//         </div>

//         <div className="sm:hidden w-[45px] h-[45px] dark:bg-shoorah-darkBgColor hover:dark:bg-shoorah-darkBgColor dark:text-white flex justify-center items-center text-sm font-medium rounded-[50%] bg-indigo-50 text-indigo-600">
//           {currentPage}
//         </div>

//         <li
//           className={`${currentPage === lastPage ? 'opacity-75' : 'cursor-pointer'} flex`}
//           onClick={currentPage !== lastPage ? onNext : undefined}
//         >
//           <span
//             className={`relative inline-flex text-shoorah-lightBlack dark:bg-shoorah-darkBgColor dark:border-none dark:hover:bg-shoorah-darkBgColor dark:text-white items-center rounded-3xl border-[1.5px] border-shoorah-lightBlack bg-white px-5 py-[7px] text-[16px] font-medium hover:bg-gray-50 focus:z-20`}
//           >
//             <span className="md:block hidden">Next page</span>
//             {/* <ArrowRightIcon className="h-5 w-5 md:ml-2" aria-hidden="true" /> */}
//           </span>
//         </li>
//       </ul>
//     </div>
//   );
// };

// Pagination.propTypes = {
//   onPageChange: PropTypes.func,
//   totalCount: PropTypes.number,
//   siblingCount: PropTypes.number,
//   currentPage: PropTypes.number,
//   pageSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
// };

// export default Pagination;
import { PaginationData } from "../../../utils/pageContent";

const Pagination = ({ currentPage, totalCount, pageSize, onPageChange, disabled = false }) => {
  const totalPages = Math.ceil(totalCount / pageSize);
  const getVisiblePageNumbers = () => {
    if (totalPages <= 5) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    if (currentPage <= 3) {
      return [1, 2, 3, 4, 5, '...'];
    }

    if (currentPage >= totalPages - 2) {
      return ['...', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    }

    return [
      '...',
      currentPage - 2,
      currentPage - 1,
      currentPage,
      currentPage + 1,
      currentPage + 2,
      '...'
    ];
  };

  const visiblePageNumbers = getVisiblePageNumbers();

  return (
    <div className="xl:px-8 lg:px-6 px-4 py-[18px] sm:mt-6 mt-4 bg-white dark:bg-shoorah-darkBgTabColor dark:border-none border border-gray-200 lg:rounded-2xl rounded-xl flex sm:justify-between justify-center mb-0 items-center">
      <div className="hidden sm:flex">
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1 || disabled}
          className="h-[40px] px-6 border border-shoorah-lightBlack dark:border-shoorah-darkBg dark:text-shoorah-darkBg rounded-full text-shoorah-lightBlack bg-transparent disabled:opacity-50 transition-all"
        >
          {PaginationData.previousData}
        </button>
      </div>
      <div className="lg:flex hidden min-w-[254px] items-center gap-2 justify-center">
        {visiblePageNumbers.map((number, index) => (
          <button
            key={index}
            onClick={() =>
              typeof number === 'number' && currentPage !== number && onPageChange(number)
            }
            className={`w-[55px] h-[55px] font-medium rounded-full text-xl ${currentPage === number
              ? 'bg-shoorah-active text-white transition-all '
              : 'dark:text-shoorah-darkBg text-shoorah-lightBlack hover:bg-shoorah-darkBg hover:text-shoorah-lightBlack dark:hover:text-shoorah-lightBlack transition-all scale-100'
              }`}
            disabled={typeof number !== 'number'}
          >
            {typeof number === 'number' ? (number < 10 ? `0${number}` : number) : '...'}
          </button>
        ))}
      </div>
      <div className="flex lg:hidden md:min-w-[254px] items-center gap-2 justify-center">
        {visiblePageNumbers?.slice(0, 3).map((number, index) => (
          <button
            key={index}
            onClick={() =>
              typeof number === 'number' && currentPage !== number && onPageChange(number)
            }
            className={`w-[40PX] h-[40PX] font-medium rounded-full text-LG ${currentPage === number
              ? 'bg-shoorah-active text-white transition-all '
              : 'dark:text-shoorah-darkBg text-shoorah-lightBlack hover:bg-shoorah-darkBg hover:text-shoorah-lightBlack dark:hover:text-shoorah-lightBlack transition-all scale-100'
              }`}
            disabled={typeof number !== 'number'}
          >
            {typeof number === 'number' ? (number < 10 ? `0${number}` : number) : '...'}
          </button>
        ))}
      </div>
      <div className="hidden sm:flex">
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages || disabled}
          className="h-[40px] px-6 bg-shoorah-active text-shoorah-darkBg rounded-full disabled:opacity-50 transition-all"
        >
          {PaginationData.nextData}
        </button>
      </div>
    </div>
  );
};

export default Pagination;
